import type { LoadTranslationsQuery } from '#build/graphql-operations'
import { defineEasyTextsLoader } from 'nuxt-easy-texts/loader'
import { mapDrupalTexts } from 'nuxt-easy-texts/drupal'

type MappedTranslations = ReturnType<typeof mapDrupalTexts>

function getTranslations(v?: LoadTranslationsQuery): MappedTranslations {
  return mapDrupalTexts(v?.translations)
}

export default defineEasyTextsLoader(() => {
  const language = useCurrentLanguage()
  return {
    async load() {
      try {
        const data = await useGraphqlQuery('loadTranslations')
        return getTranslations(data.data)
      } catch (e) {
        console.error('Failed to load translations', e)
        return {}
      }
    },
    reloadTrigger() {
      return computed(() => language.value)
    },
  }
})
